<script setup>
import { getI18n } from '@/plugins/i18n'
import { useVModel } from '@vueuse/core'
import { useRouter } from 'vue-router'

import ProjectListItem from '@/components/shared/ProjectListItem.vue'

const i18n = getI18n()
const router = useRouter()

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      dialogShow: false,
      warnings: [],
    }),
  },
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])
const value = useVModel(props, 'modelValue', emit)

// Open the Projects page filtered to the clicked project in a new tab.
const openProject = (project) => {
  if (!project?.id) return
  const url = router.resolve({ name: 'projects', query: { projectId: project.id } }).href
  window.open(url, '_blank')
}
</script>
<template>
  <q-dialog v-model="value.dialogShow" persistent class="dialog-xxs">
    <q-card>
      <q-card-section class="row items-center" style="flex-flow: row;">
        <q-avatar
          icon="mdi-alert"
          color="warning"
          text-color="white"
          size="md"
        />
        <span class="q-ml-sm">{{ value.blocking ? value.message : `${value.message}. ${i18n.t('warning.archiveSuggestion')}?` }}</span>
      </q-card-section>
      <q-card-section v-if="value.warnings?.length">
        <q-list>
          <project-list-item
            v-for="warning in value.warnings"
            :key="warning.project?.id"
            clickable
            show-staff
            :start="warning.project.start"
            :end="warning.project.end"
            :item="warning.project"
            @click="openProject(warning.project)"
          />
        </q-list>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          :label="value.blocking ? i18n.t('common.close') : i18n.t('common.cancel')"
          @click="emit('cancel')"
        />
        <q-btn
          v-if="!value.blocking"
          v-close-popup
          flat
          :label="i18n.t('common.confirm')"
          color="primary"
          @click="emit('confirm')"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
